<template>
  <div>
    <el-form-item prop="to-info"></el-form-item>
    <div class="col-12 sector receiver-sector px-3">
      <div class="row">
        <div class="sector__header">{{ t("orders.recipientInfo") }}</div>
        <div class="sector__content">
          <div class="row receiver-sector__user-info">
            <div class="col-12 address-item">
              <div v-if="showToInfo" class="row">
                <div class="col-12 col-md-3">
                  <el-form-item :label="t('users.name')" prop="to_name">
                    <el-input v-model="form.to_name" placeholder="必填" size="large" maxlength="50" />
                  </el-form-item>
                </div>
                <div class="col-12 col-md-4">
                  <el-form-item :label="t('users.phone')" prop="to_mobile">
                    <el-input v-model="form.to_mobile" placeholder="必填" size="large" maxlength="20" />
                  </el-form-item>
                </div>
              </div>
              <div v-else class="row" hidden>
                <div class="col-12 col-md-3">
                  <el-form-item :label="t('users.name')" prop="buyer_name">
                    <el-input v-model="form.buyer_name" disabled size="large" />
                  </el-form-item>
                </div>
                <div class="col-12 col-md-4">
                  <el-form-item :label="t('users.phone')" prop="buyer_mobile">
                    <el-input v-model="form.buyer_mobile" disabled size="large" />
                  </el-form-item>
                </div>
              </div>
              <slot></slot>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { watch, ref, computed } from 'vue'
import { useI18n } from "vue-i18n"
import { useVModel } from '@vueuse/core'

const props = defineProps({
  modelValue: Object,
  showToInfo: Boolean,
})
const emit = defineEmits(['update:modelValue'])

const { t, locale } = useI18n()
const form = useVModel(props, 'modelValue', emit)

</script>
